import { useGetRegionalSubstitutionsQuery } from "@/services/regional-substitution";
import {
  IRegionalSubstitution,
  IRegionalSubstitutionParams,
} from "@/@types/regional-substitution";
import { Meta } from "@/@types/paginated";

interface UseDataResult {
  substitutions: IRegionalSubstitution[];
  meta: Meta | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
  refetch: () => void;
}

export const useRegionalSubstitutionData = (
  params: IRegionalSubstitutionParams,
): UseDataResult => {
  const { data, isLoading, isFetching, error, refetch } =
    useGetRegionalSubstitutionsQuery(params);

  return {
    substitutions: data?.data ?? [],
    meta: data?.meta,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};
